import type { Locale } from "../Locale.js";
import type { OrderProductInfo } from "../OrderProductInfo.js";

export function getProductHeadingWithAttributes(
	locale: Locale,
	product: Pick<OrderProductInfo, "name" | "attributes">,
): string {
	let text = product.name[locale];
	for (const attribute of product.attributes) {
		text += ` — ${attribute.value.label[locale]}`;
	}
	return text;
}
